import { render, staticRenderFns } from "./Terms.html?vue&type=template&id=92262cc8&scoped=true&"
import script from "./Terms.ts?vue&type=script&lang=ts&"
export * from "./Terms.ts?vue&type=script&lang=ts&"
import style0 from "./Other.css?vue&type=style&index=0&id=92262cc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92262cc8",
  null
  
)

export default component.exports